import { Mission } from 'models/mission/Mission';
import api, { CrudRestApi } from '../api';
import {
    missionsFailure,
    missionsPending,
    // getMissionFailure,
    // getMissionPending,
    // getMissionsFailure,
    // getMissionsPending,
    getMissionsSuccess,
    getMissionSuccess,
    updateMissionSuccess,
    getCurrentMissionSuccess,
    missionCancelSuccess,
    executeCurrentMissionSuccess,
    clearDroneCommandsSuccess,
    missionAssignSuccess,
} from 'store/actions/missions';
// import {
//     getMissionsSuccess,
//     getMissionsPending,
//     getMissionsFailure,
//     getMissionPending,
//     getMissionSuccess,
//     getMissionFailure,
// } from 'store/reducers/mission';
import { v4 as uuidv4 } from 'uuid';
const apiUrl = 'drone-missions';

const rest = CrudRestApi(apiUrl, Mission);

// Helper to serialize error for Redux (Redux requires serializable values)
const serializeError = error => {
    if (!error) return null;
    return {
        message: error.message || 'An error occurred',
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
    };
};

export const modifyDataMission = data => {
    if (!data) return data;
    if (!data.steps || !Array.isArray(data.steps)) {
        return { ...data, steps: [], coordinates: [] };
    }
    let coordinates = [];
    let points = [];
    data.steps.forEach((step, index) => {
        data.steps[index]['id'] = data.steps[index]['id'] || uuidv4();
        if (!step.lat || !step.lon) return;
        step['coordinates'] = [step.lat, step.lon];
        step['ordinal'] = step.ordinal || index + 1;
        points.push(step);
    });
    coordinates = points.map(point => point.coordinates);
    return {
        ...data,
        ...{ coordinates, points },
    };
};

const getMissions = async () => {
    const { data } = await api.get(`${apiUrl}`);
    return data;
};

const updateMissionHeader = async postData => {
    const { data } = await api.put(`${apiUrl}`, postData);
    return data;
};

export const getAllMissions = () => {
    return async dispatch => {
        dispatch(missionsPending());
        try {
            const { data } = await api.get(`${apiUrl}`);
            dispatch(getMissionsSuccess(data?.data));
            return data?.data;
        } catch (error) {
            dispatch(missionsFailure(serializeError(error)));
            throw error;
        }
    };
};

export const updateMission = item => {
    return async dispatch => {
        dispatch(missionsPending());
        try {
            let { data } = await api.put(`${apiUrl}`, item);
            dispatch(updateMissionSuccess(modifyDataMission(data)));
            return data;
        } catch (error) {
            dispatch(missionsFailure(serializeError(error)));
            throw error;
        }
    };
};

const createMission = async item => {
    const { data } = await api.post(`${apiUrl}`, item);
    return data;
};

const missionAssign = missionAssign => {
    return async dispatch => {
        dispatch(missionsPending());
        try {
            let { data } = await api.post(`${apiUrl}/assign`, missionAssign);
            dispatch(missionAssignSuccess(modifyDataMission(data)));
            return data;
        } catch (error) {
            dispatch(missionsFailure(serializeError(error)));
            throw error;
        }
    };
};

const getMissionById = id => {
    return async dispatch => {
        dispatch(missionsPending());
        try {
            let { data } = await api.get(`${apiUrl}/${id}`);
            const mission = data?.data || data;
            dispatch(getMissionSuccess(modifyDataMission(mission)));
            return mission;
        } catch (error) {
            dispatch(missionsFailure(serializeError(error)));
            throw error;
        }
    };
};

export const getCurrentMission = id => {
    return async dispatch => {
        dispatch(missionsPending());
        try {
            let { data } = await api.get(`${apiUrl}/current/${id}`);
            const mission = data?.data || data;
            dispatch(getCurrentMissionSuccess(modifyDataMission(mission)));
            return mission;
        } catch (error) {
            dispatch(missionsFailure(serializeError(error)));
            throw error;
        }
    };
};

const cancelCurrentMission = boardId => {
    return async dispatch => {
        dispatch(missionsPending());
        try {
            let { data } = await api.post(`${apiUrl}/cancel/${boardId}`);
            dispatch(missionCancelSuccess(modifyDataMission(data)));
            return data;
        } catch (error) {
            dispatch(missionsFailure(serializeError(error)));
            throw error;
        }
    };
};

const executeCurrentMission = boardId => {
    return async dispatch => {
        dispatch(missionsPending());
        try {
            let { data } = await api.post(`${apiUrl}/execute/${boardId}`);
            dispatch(executeCurrentMissionSuccess(modifyDataMission(data)));
            return data;
        } catch (error) {
            dispatch(missionsFailure(serializeError(error)));
            throw error;
        }
    };
};

const clearDroneCommands = boardId => {
    return async dispatch => {
        dispatch(missionsPending());
        try {
            let { data } = await api.post(
                `${apiUrl}/clear-commands/${boardId}`,
            );
            dispatch(clearDroneCommandsSuccess(modifyDataMission(data)));
            return data;
        } catch (error) {
            dispatch(missionsFailure(serializeError(error)));
            throw error;
        }
    };
};

const MissionService = {
    ...rest,
    getList: getMissions,
    getEntity: getMissionById,
    create: createMission,
    update: updateMissionHeader,
    getMissionById: getMissionById,
    createMission,
    updateMission,
    missionAssign,
    getCurrentMission,
    cancelCurrentMission,
    clearDroneCommands,
    executeCurrentMission,
};

export default MissionService;
